import { Dbs } from '../constants'
import { db } from '../utils'
import {Permissions} from "../constants/permissions";

export function target(controller, name) {

    return controller[`${name}Target`]
}

export function targets(controller, name) {

    return controller[`${name}Targets`]
}

export function toggleClass(element, className) {

    element.classList.toggle(className)
}

export function addClass(element, className) {

    element.classList.add(className)
}

export function removeClass(element, className) {

    element.classList.remove(className)
}

export function setHtml(element, html) {

    element.innerHTML = html
}

export function setText(element, text) {

    element.innerText = text
}

export function sendEvent(event, data = null) {

    dispatchEvent(new CustomEvent(event, { detail: data }))
}

export function subscribeEvent(event, listener, options = false) {

    addEventListener(event, listener, options)
}

export function unsubscribeEvent(event, listener, options = false) {

    removeEventListener(event, listener, options)
}

export function checkPermission(session, { sections }) {

    const sectionsInSession = {
        sections: []
    }

    sections.forEach((section) => {

        const newSection = {
            label: section.label,
            elements: []
        }

        section.elements.forEach((element) => {

            const permission = element.permissions
                .find((permission) => Permissions.ALL === permission)

            if (permission !== undefined) {

                newSection.elements.push(element)
            }
        })

        if (newSection.elements.length > 0) {

            sectionsInSession.sections.push(newSection)
        }
    })

    return sectionsInSession
}

export function currentUnix() {

    return Math.floor(Date.now() / 1000)
}

export function clone(object) {

    return Object.assign({}, object)
}

export function char2hex(char) {

    return '%' + ('00' + char.charCodeAt(0).toString(16)).slice(-2)
}

export function createFromForm(params, defaultParams) {

    for (const param in defaultParams) {

        if (defaultParams.hasOwnProperty(param)) {

            params.append(param, defaultParams[param])
        }
    }

    return params
}

export function createForm(params) {

    const form = new FormData()

    for (const param in params) {

        if (params.hasOwnProperty(param)) {

            form.append(param, params[param])
        }
    }

    return form
}

export function checkError(error) {

    if (error) {

        throw error
    }
}

export function decodeJson(json) {

    return JSON.parse(json)
}

export function encodeJson(json) {

    return JSON.stringify(json)
}

export function decodeDataUri(dataUri) {

    const filename = 'Foto Capturada'

    const options = {
        type: dataUri.split(',')[0].split(':')[1].split(';')[0]
    }

    return fetch(dataUri)
        .then((response) => response.arrayBuffer())
        .then((buffer) => ({
            uri: dataUri,
            file: new File([ buffer ], filename, options)
        }))
}

export function checkOs() {

    const userAgent = window.navigator.userAgent
    const platform = window.navigator.platform
    const macosPlatforms = [ 'Macintosh', 'MacIntel', 'MacPPC', 'Mac68K' ]
    const windowsPlatforms = [ 'Win32', 'Win64', 'Windows', 'WinCE' ]
    const iosPlatforms = [ 'iPhone', 'iPad', 'iPod' ]

    if (macosPlatforms.indexOf(platform) !== -1) {

        return 'MacOS'
    }

    if (iosPlatforms.indexOf(platform) !== -1) {

        return 'iOS'
    }

    if (windowsPlatforms.indexOf(platform) !== -1) {

        return 'Windows'
    }

    if (/Android/.test(userAgent)) {

        return 'Android'
    }

    if (/Linux/.test(platform)) {

        return 'Linux'
    }

    return 'Others'
}

export function fileToString(file, name = null) {

    return new Promise((resolve) => {

        const fileReader = new FileReader()

        fileReader.onload = () => {

            resolve({
                name: name || file.name,
                file: fileReader.result
            })
        }

        fileReader.readAsDataURL(file)
    })
}

export function stringToFile(string, name = null) {

    const filename = 'Evidencia Guardada'

    const options = {
        type: string.split(',')[0].split(':')[1].split(';')[0]
    }

    return fetch(string)
        .then((response) => response.arrayBuffer())
        .then((buffer) => ({
            name: name || filename,
            file: new File([ buffer ], filename, options)
        }))
}

export function createToSendFromParams(notification, params) {

    return new Promise((resolve) => {

        const toSend = {
            ...notification,
            gestiones: 1,
            visitas: notification.servicio_localizado ? 1 : 0,
            sin_visita: notification.servicio_localizado ? 0 : 1,
            params: {},
            files: {}
        }

        delete toSend._id

        const promises = []

        for (const [ key, value ] of params.entries()) {

            if (value instanceof File) {

                promises.push(fileToString(value, key))

            } else {

                toSend.params[key] = value
            }
        }

        if (promises.length > 0) {

            Promise.all(promises).then((files) => {

                files.forEach((file) => {

                    toSend.files[file.name] = file.file
                })

                resolve(toSend)
            })

            return
        }

        resolve(toSend)
    })
}

export function createParamsFromToSend(toSend) {

    return new Promise((resolve) => {

        const params = new FormData()

        for (const [ key, value ] of Object.entries(toSend.params)) {

            params.append(key, value)
        }

        const promises = []

        for (const [ key, value ] of Object.entries(toSend.files)) {

            promises.push(stringToFile(value, key))
        }

        if (promises.length > 0) {

            Promise.all(promises).then((files) => {

                files.forEach((file) => {

                    params.append(file.name, file.file)
                })

                resolve(params)
            })

            return
        }

        resolve(params)
    })
}
